import decoder from '../../../lib/decoder';

function ModelAddress(prefix) {
	this.prefix = (typeof prefix === 'string' && prefix !== '') ? prefix + '_' : '';
	
	this.disabled = false;
	
	this.fields = {
		postal_code: {
			type: decoder.type.STRING,
			value: '',
			disabled: false,
			error: false
		},
		region: {
			type: decoder.type.STRING,
			value: '',
			disabled: false,
			error: false
		},
		city: {
			type: decoder.type.STRING,
			value: '',
			disabled: false,
			error: false
		},
		street: {
			type: decoder.type.STRING,
			value: '',
			disabled: false,
			error: false
		},
		house: {
			type: decoder.type.STRING,
			value: '',
			disabled: false,
			error: false
		},
		building: {
			type: decoder.type.STRING,
			value: '',
			disabled: false,
			error: false
		},
		flat: {
			type: decoder.type.STRING,
			value: '',
			disabled: false,
			error: false
		}
	}
}

ModelAddress.prototype.decode = function (jsonUser, jsonBillingUser, fieldsMapping) {
	if (!jsonUser) jsonUser = {};
	if (!jsonBillingUser) jsonBillingUser = {};
	if (!fieldsMapping) fieldsMapping = {};
	
	for (let key in fieldsMapping) {
		if (Object.hasOwnProperty.call(fieldsMapping, key) && Object.hasOwnProperty.call(this.fields, key)) {
			let field = this.fields[key];
			
			if (Object.hasOwnProperty.call(jsonBillingUser, this.prefix + key)) {
				field.value = decoder.value(field.type, jsonBillingUser[this.prefix + key], field.value);
			}
			if (field.value) {
				field.disabled = true;
			} else {
				field.value = decoder.value(field.type, jsonUser[fieldsMapping[key]], field.value);
			}
		}
	}
};

ModelAddress.prototype.fillFormData = function (formData) {
	if (this.disabled) {
		return;
	}
	
	for (let key in this.fields) {
		if (Object.hasOwnProperty.call(this.fields, key)) {
			let field = this.fields[key];
			if (!field.disabled) {
				formData.append(this.prefix + key, field.value)
			}
		}
	}
};

ModelAddress.prototype.clearErrors = function () {
	for (let key in this.fields) {
		if (Object.hasOwnProperty.call(this.fields, key)) {
			this.fields[key].error = false
		}
	}
};

ModelAddress.prototype.setError = function (key, status) {
	if (this.prefix !== '') {
		if (key.indexOf(this.prefix) === 0) {
			key = key.replace(this.prefix, '')
		} else {
			return
		}
	}
	if (Object.hasOwnProperty.call(this.fields, key)) {
		this.fields[key].error = status
	}
};

export default ModelAddress;